import React from 'react';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import AgentTokyo from '../../characters/AgentTokyo';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { DialogueData } from '../../../../general/Dialogue';
import { t } from 'ttag';

const Intro: React.FC<ISlide> = ({ defaultHeader, nextSlide }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: AgentTokyo,
            text: t`Hello Agent. We have just received news that the world’s biggest diamond has been stolen by a criminal known as Dr Mischief.`,
            buttonText: t`Next`,
        },
        {
            character: AgentTokyo,
            text: t`The Government has tasked us with sneaking into Dr Mischief’s lair, getting into the vault and grabbing the diamond. First, we need something to call you.`,
            buttonText: t`Sure`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default Intro;
